import React, { useEffect, useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import styles from 'LearningManager/styles/UserDashboard.module.scss';
import HeaderRow from 'Pages/TenantProvider/components/HeaderRow';
import OverviewCard from 'LearningManager/components/OverviewCard';
import TrainingSection from 'LearningManager/components/TrainingSection';
import { OVERVIEW_CARDS_DATA } from 'LearningManager/constants/UserDashboard.constants';
import { useStores } from 'Hooks/useStore';

const UserDashboard: React.FC = observer(() => {
	const { userDashboardStore } = useStores();
	const { activityAssignments } = userDashboardStore;

	useEffect(() => {
		userDashboardStore.fetchLmsInstances();
		userDashboardStore.fetchLearningPathAssignments({ offset: 0 });
		userDashboardStore.fetchActivityAssignments({ offset: 0 });
	}, []);

	const overviewCards = useMemo(() => {
		const required = activityAssignments.filter((a) => a.is_required);
		const completedRequired = required.filter(
			(a) => a.status === 'completed'
		);
		const completedAll = activityAssignments.filter(
			(a) => a.status === 'completed'
		);
		const optionalRemaining = activityAssignments.filter(
			(a) => !a.is_required && a.status !== 'completed'
		);

		const overallCompletion = required.length
			? Math.round((completedRequired.length / required.length) * 100)
			: 0;

		const values: Record<string, string | number> = {
			'overall-completion': `${overallCompletion}%`,
			'courses-remaining': required.length - completedRequired.length,
			'courses-complete': completedAll.length,
			'optional-course': optionalRemaining.length
		};

		return OVERVIEW_CARDS_DATA.map((card) => ({
			...card,
			value: values[card.id] ?? card.value
		}));
	}, [activityAssignments]);

	return (
		<div>
			<HeaderRow
				title="My Courses"
				subHeading="A quick overview of your assigned training and progress"
				parentClass={styles.header}
			/>
			<div className={styles['overview-section']}>
				{overviewCards.map((card) => (
					<OverviewCard
						key={card.id}
						value={card.value}
						label={card.label}
						description={card.description}
						icon={card.icon}
						tooltip={card.tooltip}
					/>
				))}
			</div>
			<div className={styles['training-section']}>
				<TrainingSection />
			</div>
		</div>
	);
});

export default UserDashboard;
